import { Typography, Box } from "@mui/material";

import { useTheme } from "@emotion/react";

export default function SideBarSection({ title, children }) {
  const theme = useTheme();
  return (
    <Box
      className="user_info_section"
      sx={{
        padding: 2,
        borderBottom: `1px solid ${theme.palette.grey["200"]}`,
      }}
    >
      <Typography
        sx={{ color: theme.palette.grey["600"], fontWeight: "bold" }}
        variant="h6"
      >
        {title}
      </Typography>
      {children}
    </Box>
  );
}
